import Blue from "~/core";

new Blue({
  name: "exitModal",
  selector: "html",
  setup(html) {
    let isSafari = navigator.userAgent.indexOf("iPhone OS 15") != -1;
    let leaveLinks = html.querySelectorAll('a:not([href=""])');
    let leaveModal = document.createElement("div");
    leaveModal.setAttribute("class", "modal modal--leave");

    // Helper function to indicate if the given URL is whitelisted
    var isWhitelistedUrl = function (url) {
      // let url_whitelist;
      // The URL whitelist is stored in a Kentico custom table and written to
      // the page in a JS global.
      var whitelist = url_whitelist || [];
      // Get the base domain for the given URL
      var domain = url.split("/")[2];
      if (domain) {
        domain = domain.replace("www.", "");
      }
      return (
        url.indexOf("http") !== 0 ||
        whitelist.includes(domain) ||
        whitelist.includes(url)
      );
    };

    leaveLinks.forEach((leaveLink) => {
      let url = leaveLink?.href;

      if (!url) return;

      let sameSite =
        url.startsWith("#") ||
        url.startsWith("/") ||
        leaveLink.hostname.includes("fccu.org") ||
        leaveLink.hostname.includes("localhost") ||
        leaveLink.hostname.includes("fccu-web-dev-2021.bluemod.us") ||
        leaveLink.hostname.includes("fccu-web-stage-2021.bluemod.us");

      if (isWhitelistedUrl(url)) { 
        sameSite = true;
      }
      
      if (!sameSite) {
        leaveLink.setAttribute("target", "_blank");
      }

      leaveLink.addEventListener("click", (e) => {
        if (!sameSite) {
          e.preventDefault();

          leaveModal.innerHTML = `
						<div class="modal__content-wrapper" role="dialog" aria-labelledby="leaving-dialog-title leaving-dialog-text">
								<button class="modal__close modal-close__x" aria-label="close dialog"></button>
								<header class="modal-header">
										<h3 class="modal-heading" id="leaving-dialog-title">You are leaving First Community Credit Union’s website</h3>
								</header>
								<div class="modal-body">
										<a href="${leaveLink.getAttribute(
                      "href"
                    )}" class="modal-confirm btn btn--primary" target="_blank">
										Continue
										</a>
										<button class="modal__cancel btn" aria-label="cancel">Cancel</button>
								</div>
								<footer class="modal-footer">
										<p class="modal-footer__text" id="leaving-dialog-text">FCCU only links to external third-party websites we feel provide value to our members. FCCU does not have control over these external third-party sites nor are we responsible for any content presented, information collected, security, or privacy policies on any external third-party sites. By clicking continue you agree to indemnify and hold FCCU harmless in relation to your use of a third-party site. Refer to the privacy and security policies of each site for details about how the third-party external site manages information. First Community does not represent either the external third-party site or the member if the two enter into a transaction.</p>
								</footer>
						</div>
					`;
          document.querySelector("body").appendChild(leaveModal);
          let modalContent = leaveModal.querySelector(
            ".modal__content-wrapper"
          );
          isSafari
            ? (modalContent.style.maxHeight = "80vh")
            : (modalContent.style.maxHeight = null);
          leaveModal.classList.add("is-open");

          this.$scrollLock.lock(html);
          isSafari
            ? (html.style.overflow = "hidden")
            : (html.style.overflow = null);

          let modalInner = leaveModal.querySelector(".modal__content-wrapper");
          modalInner.addEventListener("click", (e) => e.stopPropagation());

          let modalClose = leaveModal.querySelector(".modal__close");
          modalClose.addEventListener("click", (e) => {
            e.preventDefault();
            leaveModal.classList.remove("is-open");
            this.$scrollLock.unlock(html);
            isSafari
              ? (html.style.overflow = "hidden")
              : (html.style.overflow = null);
            leaveLink.focus();
          });
          let modalCancel = leaveModal.querySelector(".modal__cancel");
          modalCancel.addEventListener("click", (e) => {
            e.preventDefault();
            leaveModal.classList.remove("is-open");
            this.$scrollLock.unlock(html);
            isSafari
              ? (html.style.overflow = "hidden")
              : (html.style.overflow = null);
            leaveLink.focus();
          });
          leaveModal.addEventListener("click", () => {
            leaveModal.classList.remove("is-open");
            this.$scrollLock.unlock(html);
            isSafari
              ? (html.style.overflow = "hidden")
              : (html.style.overflow = null);
            leaveLink.focus();
          });
          let confirm = document.querySelector(".modal-confirm");
          confirm.addEventListener("click", (e) => {
            leaveModal.classList.remove("is-open");
            this.$scrollLock.unlock(html);
            isSafari
              ? (html.style.overflow = "hidden")
              : (html.style.overflow = null);
          });

          leaveModal
            .querySelector(".modal-close__x")
            .addEventListener("keydown", (e) => {
              if (e.keyCode === 9 && e.shiftKey) {
                e.preventDefault();
                e.stopPropagation();
                leaveModal.querySelector(".modal__cancel").focus();
              }
            });

          leaveModal
            .querySelector(".modal__cancel")
            .addEventListener("keydown", (e) => {
              if (e.keyCode === 9 && !e.shiftKey) {
                e.preventDefault();
                e.stopPropagation();
                leaveModal.querySelector(".modal-close__x").focus();
              }
            });

          leaveModal.querySelector(".modal-confirm").focus();
        } else {
          return;
        }
      });
    });
  },
});
